import React from "react";
import "./../../AttestationPage/AttestationEdu/AttestationEdu.css";
const ApostilleEduTime = () => {
  return (
    <div className="atteEduTimeContainer">
      <h2>
        Total time period to get degree certificate apostille agency in
        Bangalore:
      </h2>
      <div className="atteEduTimeContent">
        <p>
          The duration for apostille services can vary based on the type of
          document, issuing authority, and the destination country. Generally,
          degree certificate apostille through{" "}
          <a href="https://goodwayattestation.com/wes-attestation-bangalore">
            Certificate Apostille Services in Bangalore
          </a>{" "}
          takes about 8 to 10 working days. However, depending on the complexity
          of the document and the state it originates from, it may take up to a
          few weeks. Goodway Attestation ensures timely processing and keeps
          clients updated at every stage.
        </p>
      </div>
    </div>
  );
};

export default ApostilleEduTime;
